type ButtonType = "button" | "reset" | "submit" | undefined;

export const isValidButtonType = (type: unknown): type is ButtonType => {
	if (typeof type === "undefined") return true;

	if (typeof type === "string" && ["button", "reset", "submit"].includes(type))
		return true;

	return false;
};
